import { render } from "./AboutAu.vue?vue&type=template&id=1253a82e&scoped=true"
import script from "./AboutAu.vue?vue&type=script&lang=js"
export * from "./AboutAu.vue?vue&type=script&lang=js"

import "./AboutAu.vue?vue&type=style&index=0&id=1253a82e&scoped=true&lang=css"

import exportComponent from "/Users/apple/Projects/opm/yuzhangmen/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1253a82e"]])

export default __exports__